import React, { useState, useEffect } from 'react';
import useMeasure from 'react-use-measure';
import { useStaticQuery, graphql } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import SearchIcon from './icons/SearchIcon';
import MenuIcon from './icons/MenuIcon';
import Link from './Flexlink';
import $ from 'jquery';

const MainNav = (props) => {
  const [ref, parentBounds] = useMeasure();

  const [navclass, setNavClass] = useState(false);
  const handleToggle = () => {
    setNavClass(!navclass);
  };

  const [toggledParent, setToggledParent] = useState(null);
  const toggleParent = (theIndex) => {
    if (theIndex === toggledParent) {
      setToggledParent(null);
    } else {
      setToggledParent(theIndex);
    }
  };

  const data = useStaticQuery(graphql`
    query MyQuery {
      wpMenu(name: { eq: "Main Menu" }) {
        menuItems {
          nodes {
            label
            url
            childItems {
              nodes {
                label
                url
                cssClasses
              }
            }
            parentId
            cssClasses
          }
        }
      }
    }
  `);

  useEffect(() => {
    const isBrowser = typeof window !== 'undefined';

    if (isBrowser) {
      let thesearch = '';
      const livesite = 'https://zornsofbethpage.com/';

      $('#search-icon').on('click', function (e) {
        thesearch = $('#searchfield').val();
        e.preventDefault();
        getPages();
      });

      $('#searchfield').on('keydown', function (evt) {
        const keyCode = evt.keyCode;
        if (keyCode === 13) {
          thesearch = $('#searchfield').val();
          evt.preventDefault();
          getPages();
        }
      });

      function renderPage(page) {
        let cardContent = '';
        page.forEach(function (item) {
          const iURL = item.link.replace('https://zorns.wpengine.com/', livesite);
          cardContent += `<div class="result"><p><a class="cover" href="${iURL}" target="_blank">${item.title.rendered}</a></p></div>`;
        });
        $('#hits').html(cardContent);
      }

      //Pages
      function getPages() {
        const rootUrl = `https://zorns.wpengine.com/wp-json/relevanssi/v1/search/?per_page=100&keyword=${thesearch}`;
        if (thesearch !== '') {
          $.ajax({
            method: 'GET',
            url: rootUrl,
            dataType: 'json',
          })
            .done(function (response) {
              renderPage(response);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
              console.log(jqXHR);
              console.log(textStatus);
              console.log(errorThrown);
            });
        } else {
          $('#hits').html('');
        }
      }
    }
  }, []);

  return (
    <header
      ref={ref}
      className={`main-nav container ${
        parentBounds.width < props.mobileBelow ? 'mobile' : ''
      } ${navclass ? 'navigating' : ''}`}
    >
      <div id="logo">
        <Link to="/" className="navbar-item">
          <StaticImage alt="Zorn's of Bethpage logo" src="../images/zorns-of-bethpage-logo.svg" width={240} />
        </Link>
      </div>

      <div id="menu">
        <div id="menu-search">
                        
                        <a href="tel:516-731-5500">(516) 731-5500</a>

                        {props.search &&
                            <React.Fragment>
                                <div id="searchbox">
                                    <input id="searchfield" type="text" placeholder="search..."></input>
                                    <div id="search-icon">
                                        <SearchIcon />
                                    </div>
                                    <div id="hits"></div>
                                </div>
                            
                                
                            </React.Fragment>
                        }
                    </div>
                    <ul className="menu">

                        {data.wpMenu.menuItems.nodes.map((item, i) => (

                            (item.parentId == null &&

                            <li key={item.label} className={`${item.cssClasses} ${toggledParent === i ? "current-menu-item" : ""}`}>

                                <Link
                                className={`navbar-item ${item.childItems.nodes && item.childItems.nodes.length > 0 ? "menu-item-has-children" : "" }`}
                                to={item.url}
                                activeClassName="active"
                                partiallyActive={true}
                                role="menuitem"
                                >
                                {item.label}
                                </Link>

                                {item.childItems.nodes && item.childItems.nodes.length > 0 &&

                                <React.Fragment>
                                    <ul className="sub-menu"> 
                                        {item.childItems.nodes.map(child => (
                                        <li key={child.url} className={item.cssClasses}>
                                            <Link
                                            className="navbar-item"
                                            to={child.url}
                                            activeClassName="active"
                                            partiallyActive={true}
                                            role="menuitem"
                                            >
                                            {child.label}
                                            </Link>
                                        </li>
                                        ))}
                                    </ul>
                                    <button className="toggler" onClick={() => {toggleParent(i)}}>toggle</button>
                                </React.Fragment>
                                
                                }

                            </li>
                            )
                            
                        ))}

                    </ul>
                    
                </div>
        
                

                <button id="menu-icon" onClick={handleToggle} onKeyDown={handleToggle}>
                    <MenuIcon />
                </button>

            </header>
            
    )
}

export default MainNav;

